

// Función que devuelve la lista actualizada de chats luego de eliminar un chat.
export const onHandleEndSession = (data, sessions, setSessions) => {
   if (sessions){ // Filtrar la sesión existente con el IdSession proporcionado en data
    let existingSession = sessions.find(session => session.IdSession === data.IdMessageSession);

    if (existingSession) {
        // Actualizar la sesión existente con la fecha de finalización
        const updatedSession = {
            ...existingSession,
            Fin: data.Fin
        };

        // Actualizar el estado con la sesión actualizada
        setSessions(prevSessions => {
            return prevSessions.map(session => {
                // Si la sesión actual es la que se está actualizando, devolver la sesión actualizada
                if (session.IdSession === updatedSession.IdSession) {
                    return updatedSession;
                }
                // De lo contrario, devolver la sesión sin cambios
                return session;
            });
        });
    }}
};
